<template>
  <page>
    <module enable-flex>
      <m-search ref="search" @search="searchHandle">
        <c-form>
            <c-form-item type="checkbox" label="状态" name="state" :options="templateState"></c-form-item>
            <c-form-item type="input" label="联系人" name="contacts"></c-form-item>
            <c-form-item type="input" label="联系电话" name="phone_number"></c-form-item>
            <c-form-item type="datetime" label="提交时间" start-name="start_create_date" end-name="end_create_date"></c-form-item>
        </c-form>
      </m-search>

      <c-table ref="table" code="member_userfeedback_list">
        <c-table-column
            label="状态"
            name="state"
			width="80"
        >
          <template v-slot="{data}">
              <span v-if="data.state == 1" style="color: red">待处理</span>
              <span v-if="data.state == 2" style="color: green">已处理</span>
          </template>
        </c-table-column>

        <c-table-column
            label="反馈类型"
            name="typeName"
			width="90"
        >
        </c-table-column>

        <c-table-column
            label="问题内容"
            name="content"
			width="300"
        >
        </c-table-column>
        <c-table-column
            label="联系人"
            name="contacts"
			width="100"
        >
        </c-table-column>
        <c-table-column
            label="联系电话"
            name="phoneNumber"
			width="110"
        >
        </c-table-column>
        <c-table-column
            label="提交时间"
            name="createDate"
			width="150"
        >
        </c-table-column>

        <c-table-column
            type="button"
            fixed="right"
            label="操作"
            width="110"
        >
          <template v-slot="row">
            <c-table-button @click="detail(row)" power="b_member_userfeedback_detail">查看</c-table-button>
            <c-table-button @click="editHandle(row)" v-if="row.data.state == 1" power="b_member_userfeedback_edit">处理
            </c-table-button>
          </template>
        </c-table-column>
      </c-table>
    </module>

    <c-dialog ref="dialog" title="处理会员反馈问题" width="600" height="300" @resolve="addChild">
      <c-form ref="form">
        <c-form-item type="select" label="状态：" :options="templateState" name="state" required></c-form-item>
        <c-form-item type="textarea" label="处理意见：" name="deal_suggest"></c-form-item>
      </c-form>
    </c-dialog>

    <c-dialog ref="dialog2" title="会员反馈问题" width="800" height="500" :button="false">
      <c-detail title="">
        <c-detail-item label="处理状态：" full name="type">
            <template v-slot="{data}">
                <span v-if="detailData.state == 1" style="color: red">待处理</span>
                <span v-if="detailData.state == 2" style="color: green">已处理</span>
            </template>
        </c-detail-item>
        <c-detail-item label="问题类型：" full name="type">
          {{ detailData.typeName }}
        </c-detail-item>
        <c-detail-item label="联系人：" full>
          {{ detailData.contacts }}
        </c-detail-item>
        <c-detail-item label="联系电话：" full>
          {{ detailData.phoneNumber }}
        </c-detail-item>
        <c-detail-item label="问题内容：" full>
          {{ detailData.content }}
        </c-detail-item>
        <c-detail-item label="图片：" full>
          <c-image v-if="detailData.suggestImg" v-for="(medias, j) in detailData.suggestImgList" :key="j" class="img" :src="medias" size="80" preview></c-image>
        </c-detail-item>
        <c-detail-item label="处理意见：" full>
          {{ detailData.dealSuggest }}
        </c-detail-item>
      </c-detail>
    </c-dialog>
  </page>
</template>

<script>
var urls = {
  list: '/userfeedback/list', //列表数据
  del: '/news_info/del', //删除
  sort: '/news_info/sort', //排序
  detail: '/userfeedback/detail', //详情
  update: '/userfeedback/deal', //更新
}
export default {
  name: 'm_member_userfeedback',

  data() {
    return {
      detailData: {},
      templateState: [
        {name: '待处理',value: 1},
        {name: '已处理',value: 2}
      ]
    }
  },

  mounted() {
    this.$refs.search.search();

    this.$bus.$on(name + '.update', page => {
      this.$refs.table.update(page);
    });
  },

  methods: {
    searchHandle(data) {
      this.$refs.table.load({
        url: urls.list,
        data
      });
    },
    editHandle(row) {
      this._edit = row.data.id;
      this.$refs.form.set({
            state: 2
      });
      this.$refs.dialog.open();
    },
    detail(row) {
      this.detailData = row.data;
      this.$refs.dialog2.open();
    },

    deleteHandle(row) {
      var val = row.data;
      this.$confirm({
        text: '确定要删除【' + val.name + '】吗？',  // 提示内容,
        buttonName: '确定',  // 确定按钮文字
        cancelButton: true,  // 是否显示取消按钮
        resolve: () => {
          this.request({
            url: urls.del,
            data: {id: val.id},
            loading: true,
            success: data => {
              this.$message({
                text: '操作成功',
                icon: 'success'
              });
              this.$refs.table.update();
            }
          });
        },  // 确定按钮回调
        cancel: () => {
        },  // 取消按钮回调
      });
    },

    sortHandle(row, type, next) {
      this.request({
        url: urls.sort,
        data: {
          id: row.data.id,
          parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
          type: ['top', 'bottom'].includes(type) ? type : '',
          id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
          id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
        },
        loading: true,
        success: data => {
          next();
        }
      });
    },

    addChild(stop) {
      stop();
      var data = this.$refs.form.serialize();
      if (!data.state) {
        this.$message({
          text: '请选择状态'
        });
        return;
      }

      this.request({
        url: urls.update,
        data: Object.assign(data, {
          id: this._edit
        }),
        loading: true,
        success: data => {
          this.$message({
            text: '处理成功'
          });
          this.$refs.dialog.close();
          this.$refs.table.update();
        }
      });
    }
  }
}
</script>